import { Input, Output, EventEmitter, Inject } from '@angular/core';

import { Comunicado } from '../base/vo/comunicado';

export class ComunicadoBase {

    @Input() comunicado: Comunicado;
    @Input() indice: number;
    @Input() expandido: boolean;

    @Output() ocultarOuExpandirEvent = new EventEmitter<number>();
    
    protected btnConfirmacao: string;

    constructor(){}

    public getStatusComunicado(comunicado: Comunicado): string {
        return comunicado.lido ? 'status-msg msg-lida' : 'status-msg nova-msg';
    }

    public getInfoMsg(comunicado: Comunicado): string {
        return comunicado.lido ? 'Lida' : 'Nova MSG';
    }

    public ocultarOuExpandir(){
        this.ocultarOuExpandirEvent.emit(this.indice);
    }

    public getTextOcultarOuExpandir(): string{
        return this.expandido ? '- Ocultar' : '+ Leia mais';
    }

}


// WEBPACK FOOTER //
// ./src/app/components/comunicados/comunicado-base.ts